import HelperMixin from '../../../Shared/HelperMixin.vue';

export default {
    name: 'GiftCharge',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.loginDetails || this.loginDetails.userType != 1) {
            this.logout();
            return;
        }
        this.LoadActiveCount();
    },

    data() {
        return {
            ScreenTitle: 'شحن رصيد الهدية',
            Students: [],
            studentsLoading: false,
            activeCount: 0,
            ruleForm: {
                Scope: 'one',
                StudentId: null,
                Value: null,
                Descriptions: ''
            },
            rules: {
                Value: this.$helper.Required()
            }
        };
    },

    methods: {
        LoadActiveCount() {
            this.$http.GetGiftActiveCount()
                .then(response => {
                    this.activeCount = response.data.count || 0;
                })
                .catch(() => { this.activeCount = 0; });
        },

        SearchStudents(query) {
            if (!query) {
                this.Students = [];
                return;
            }
            this.studentsLoading = true;
            this.$http.GetStudents(1, 20, query)
                .then(response => {
                    this.studentsLoading = false;
                    this.Students = response.data.info || [];
                })
                .catch(() => {
                    this.studentsLoading = false;
                    this.Students = [];
                });
        },

        Submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) return;
                const value = Number(this.ruleForm.Value);
                if (!value || value <= 0) {
                    this.$message.error('الرجاء إدخال قيمة صحيحة');
                    return;
                }

                if (this.ruleForm.Scope === 'one') {
                    if (!this.ruleForm.StudentId) {
                        this.$message.error('الرجاء اختيار الطالب');
                        return;
                    }
                    this.$blockUI.Start();
                    this.$http.ChargeStudentsGift({
                        StudentId: this.ruleForm.StudentId,
                        Value: value,
                        Descriptions: this.ruleForm.Descriptions
                    }).then(() => {
                        this.$blockUI.Stop();
                        this.$message.success('تم شحن رصيد الهدية بنجاح');
                        this.ruleForm.StudentId = null;
                        this.ruleForm.Value = null;
                        this.ruleForm.Descriptions = '';
                    }).catch(() => {
                        this.$blockUI.Stop();
                    });
                    return;
                }

                this.$confirm(
                    'سيتم إضافة ' + value + ' د.ل لـ ' + this.activeCount + ' طالب نشط. هل تريد المتابعة؟',
                    'تأكيد الشحن للجميع',
                    { confirmButtonText: 'تنفيذ', cancelButtonText: 'إلغاء', type: 'warning' }
                ).then(() => {
                    this.$blockUI.Start();
                    this.$http.ChargeStudentsGiftAll({
                        Value: value,
                        Descriptions: this.ruleForm.Descriptions
                    }).then((response) => {
                        this.$blockUI.Stop();
                        const count = response.data.count || this.activeCount;
                        this.$message.success('تم شحن الهدية لـ ' + count + ' طالب');
                    }).catch(() => {
                        this.$blockUI.Stop();
                    });
                }).catch(() => {});
            });
        }
    }
};
